const HTTP_STATUS_CODES = {
  OK: { code: '200', reason: 'OK' },
  CREATED: { code: '201', reason: 'Created' },
  BAD_REQUEST: { code: '400', reason: 'Bad Request' },
  UNAUTHORIZED: { code: '401', reason: 'Unauthorized' },
  FORBIDDEN: { code: '403', reason: 'Forbidden' },
  NOT_FOUND: { code: '404', reason: 'Not Found' },
  INTERNAL_SERVER_ERROR: { code: '500', reason: 'Internal Server Error' },
};

function checkResponseStatusCode(response, status) {
  return response?.status?.toString() === status.code;
}

function is200(response) {
  return checkResponseStatusCode(response, HTTP_STATUS_CODES.OK);
}

function is400(response) {
  return checkResponseStatusCode(response, HTTP_STATUS_CODES.BAD_REQUEST);
}

function is401(response) {
  return checkResponseStatusCode(response, HTTP_STATUS_CODES.UNAUTHORIZED);
}

function is403(response) {
  return checkResponseStatusCode(response, HTTP_STATUS_CODES.FORBIDDEN);
}

function is404(response) {
  return checkResponseStatusCode(response, HTTP_STATUS_CODES.NOT_FOUND);
}

function is500(response) {
  return checkResponseStatusCode(response, HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR);
}


/**
 * Shared `throwOnError` predicate for page-critical list queries (audit
 * dbc15bf7). Surfaces 403/404/5xx — and network failures (no response) — as the
 * full-page error/SystemState, while letting 400/validation errors stay inline.
 * Centralizes the copy that was inlined across the list pages + the shared paged
 * query hook.
 */
function isPageCriticalError(error) {
  const status = error?.response?.status;
  return !error?.response || status === 403 || status === 404 || status >= 500;
}


export {
  is200,
  is400,
  is401,
  is403,
  is404,
  is500,
  isPageCriticalError,
};
